export const CONTACT = {
  orgName: 'GAAG Casa Letizia',
  vatNumber: '13037730010',
  address: 'Via Vandalino 25, 10093 Collegno (TO)',
  addressLabel: 'Sede legale: Via Vandalino 25, 10093 Collegno (TO)',
  phone: 'dott. Davide Vessio cell. 335 6763007',
  email: 'dvessio7@hotmail.com',
  mapEmbedSrc:
    'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2817.714700928199!2d7.593209076589851!3d45.071298259567364!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47886b6f20dba39f%3A0xb5669395c483fd69!2sVia%20Vandalino%2C%2025%2C%2010093%20Collegno%20TO!5e0!3m2!1sit!2sit!4v1774343553787!5m2!1sit!2sit',
};
